import { render, staticRenderFns } from "./Tiho.vue?vue&type=template&id=27d05ce6&scoped=true&"
import script from "./Tiho.vue?vue&type=script&lang=js&"
export * from "./Tiho.vue?vue&type=script&lang=js&"
import style0 from "./Tiho.vue?vue&type=style&index=0&id=27d05ce6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d05ce6",
  null
  
)

export default component.exports